module.exports = __webpack_public_path__ + "static/media/icon@2x.f3570854.png";